var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.towing.title")) + " "), _c('v-spacer'), _vm.canUpdateReport ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-plus"
    },
    on: {
      "click": _vm.startTowing
    }
  }) : _vm._e()], 1), _vm.report.towing && _vm.report.towing.length > 0 ? _c('v-card-text', [_c('partner-report-towing-detail-card', {
    staticClass: "mb-4",
    attrs: {
      "towing": _vm.reversedTowings[0],
      "report": _vm.report,
      "can-update-report": _vm.canUpdateReport,
      "hideCompanyDetails": _vm.hideCompanyDetails
    },
    on: {
      "edit": _vm.startEditTowing,
      "delete": _vm.startDeleteTowing
    }
  }), _vm.report.towing.length > 1 ? _c('m-expansion', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("showMore", {
          amount: _vm.report.towing.length - 1
        })) + " ")];
      },
      proxy: true
    }], null, false, 1948269967),
    model: {
      value: _vm.showTowings,
      callback: function callback($$v) {
        _vm.showTowings = $$v;
      },
      expression: "showTowings"
    }
  }, _vm._l(_vm.reversedTowings.slice(1), function (t) {
    return _c('partner-report-towing-detail-card', {
      key: 'towing-' + t.id,
      staticClass: "mb-2",
      attrs: {
        "towing": t,
        "report": _vm.report,
        "can-update-report": _vm.canUpdateReport,
        "hideCompanyDetails": _vm.hideCompanyDetails
      },
      on: {
        "edit": _vm.startEditTowing,
        "delete": _vm.startDeleteTowing
      }
    });
  }), 1) : _vm._e()], 1) : _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-tow-truck",
      "text": _vm.$t('objects.towing.title')
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("objects.towing.title"),
      "isDialogActive": _vm.isCreateTowingDialogOpen,
      "rightDisabled": !_vm.isTowingValid,
      "rightLoading": _vm.isTowingLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isCreateTowingDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isCreateTowingDialogOpen = $event;
      },
      "rightClick": _vm.addTower,
      "hover:action": function hoverAction($event) {
        return _vm.$refs.towingCreateForm.validate();
      }
    }
  }, [_c('v-form', {
    ref: "towingCreateForm",
    model: {
      value: _vm.isTowingValid,
      callback: function callback($$v) {
        _vm.isTowingValid = $$v;
      },
      expression: "isTowingValid"
    }
  }, [_c('towing-form', {
    attrs: {
      "report": _vm.report,
      "destination": _vm.report.workShopCompany
    },
    model: {
      value: _vm.towing,
      callback: function callback($$v) {
        _vm.towing = $$v;
      },
      expression: "towing"
    }
  })], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("edit"),
      "isDialogActive": _vm.isEditTowingDialogOpen,
      "rightDisabled": !_vm.isTowingValid,
      "rightLoading": _vm.isTowingLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isEditTowingDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isEditTowingDialogOpen = $event;
      },
      "rightClick": _vm.updateTowing,
      "hover:action": function hoverAction($event) {
        return _vm.$refs.towingUpdateForm.validate();
      }
    }
  }, [_c('v-form', {
    ref: "towingUpdateForm",
    model: {
      value: _vm.isTowingValid,
      callback: function callback($$v) {
        _vm.isTowingValid = $$v;
      },
      expression: "isTowingValid"
    }
  }, [_c('towing-form', {
    attrs: {
      "showCompany": false
    },
    model: {
      value: _vm.towing,
      callback: function callback($$v) {
        _vm.towing = $$v;
      },
      expression: "towing"
    }
  })], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('delete'),
      "isDialogActive": _vm.isDeleteTowingDialogOpen,
      "rightDisabled": false,
      "rightLoading": _vm.isTowingLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteTowingDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteTowingDialogOpen = $event;
      },
      "rightClick": _vm.deleteTowing,
      "leftClick": function leftClick($event) {
        _vm.isDeleteTowingDialogOpen = false;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }